import { render } from "./MaterialProgress.vue?vue&type=template&id=37fd56ad&scoped=true"
import script from "./MaterialProgress.vue?vue&type=script&lang=js"
export * from "./MaterialProgress.vue?vue&type=script&lang=js"

import "./MaterialProgress.vue?vue&type=style&index=0&id=37fd56ad&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fd56ad"]])

export default __exports__